import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorMicrosoft = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path fill="#F35325" d="M1.043 1.043h10.435v10.435H1.043V1.043Z" />
    <path fill="#81BC06" d="M12.521 1.043h10.435v10.435H12.522V1.043Z" />
    <path fill="#05A6F0" d="M1.043 12.522h10.435v10.434H1.043V12.522Z" />
    <path fill="#FFBA08" d="M12.521 12.522h10.435v10.434H12.522V12.522Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgColorMicrosoft)
export default ForwardRef
